import { CloseOutlined } from '@ant-design/icons';
import { Button, Col,Form, Input, InputNumber, Row, Select } from 'antd';
import { Modal } from 'components';
import { useGetFacilities } from 'features/facilities';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import debounce from 'lodash/debounce';
import { useCallback,useEffect, useState } from 'react';
export const BookingReportModal = ({ onClose }: { onClose: () => void }) => {
  const [form] = Form.useForm();
  const [modalValue, setModalValue] = useState<string>('1');
  const [fields, setFields] = useState([{ id: Date.now() }]);

  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [facilityList, setFacilityList] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const { data, isFetching } = useGetFacilities(
    { page, size: pageSize, order_by: '-rank' },
    { retry: false },
  );
  useEffect(() => {
    if (data?.items?.length) {
      setFacilityList((prev) => [...prev, ...data.items]);
      if (data.items.length < pageSize) {
        setHasMore(false);
      }
    }
  }, [data]);

  const handleFinish = () => {
    onClose();
  };

  const addFieldRow = () => {
    setFields([...fields, { id: Date.now() }]);
  };

  const handleModelChange = (value: string) => {
    setModalValue(value);
    if (value === '3' || value === '4') {
      form.setFieldsValue({ commission: undefined, cap: undefined });
    }
  };

  const handleScroll = useCallback(
    debounce((e: any) => {
      const target = e.target;
      if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 100) {
        if (!isFetching && hasMore) {
          setPage((prev) => prev + 1);
        }
      }
    }, 300),
    [isFetching, hasMore],
  );

  return (
    <StyledUserModalWrapper>
      <Modal
        className='right-modal mtch_dtls_modal'
        open
        centered
        title='Booking Report Rule'
        onCancel={() => {
          document.body.style.overflow = 'auto';
          onClose();
        }}
        style={{ width: '650px' }}
        width={'650px'}
        getContainer={false}
        footer={null}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <Form form={form} layout='vertical' onFinish={handleFinish}>
          <Form.Item
            label='Select Facility'
            name='facility'
            rules={[{ required: true, message: 'Please Select a facility' }]}
          >
            <Select
              showSearch
              placeholder='Select Facility'
              loading={isFetching}
              onPopupScroll={handleScroll}
              options={facilityList.map((item) => ({
                value: item?.id,
                label: item?.name,
              }))}
            />
          </Form.Item>

          <Form.Item
            label='Select Model'
            name='model'
            rules={[{ required: true, message: 'Please Select a Model' }]}
          >
            <Select
              style={{ width: '100%' }}
              defaultValue={'1'}
              onChange={handleModelChange}
              options={[
                {
                  value: '1',
                  label: 'All booking calculation model (with cap)',
                },
                {
                  value: '2',
                  label: 'Li3ib Booking Calculation Model (without cap)',
                },
                { value: '3', label: 'Subscription Model' },
                { value: '4', label: 'Exception Subscription Model' },
                { value: '5', label: 'Suffix Model 1' },
                { value: '6', label: 'Suffix Model 2' },
                { value: '7', label: 'Suffix Model 3' },
                { value: '8', label: 'Suffix Model 4' },
              ]}
            />
          </Form.Item>

          {modalValue !== '3' && modalValue !== '4' && (
            <>
              <Form.Item
                label='Commissions Value'
                name='commission'
                rules={[
                  {
                    required: true,
                    message: 'Please enter a commission value',
                  },
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  placeholder='Enter a decimal value'
                  min={0}
                  step={0.01}
                  stringMode
                />
              </Form.Item>

              {modalValue !== '2' && (
                <Form.Item
                  label='CAP Value'
                  name='cap'
                  rules={[{ required: true, message: 'Please enter a Cap' }]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    placeholder='Enter a decimal value'
                    min={0}
                    step={0.01}
                    stringMode
                  />
                </Form.Item>
              )}
            </>
          )}

          {(modalValue === '3' || modalValue === '4') && (
            <div style={{ marginBottom: 0 }}>
              <p>
                <strong>Revenue</strong>
              </p>
              <Form layout='vertical'>
                {fields.map((field, index) => (
                  <Row
                    gutter={12}
                    key={field.id}
                    style={{ marginBottom: '0px', position: 'relative' }}
                  >
                    {modalValue !== '4' && (
                      <Col span={6}>
                        <Form.Item
                          label='Field count'
                          name={['rows', index, 'fieldCount']}
                        >
                          <Input placeholder='Enter field count' />
                        </Form.Item>
                      </Col>
                    )}
                    <Col span={6}>
                      <Form.Item
                        label='From (KD)'
                        name={['rows', index, 'from']}
                      >
                        <Input placeholder='Enter from value' />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label='To (KD)' name={['rows', index, 'to']}>
                        <Input placeholder='Enter to value' />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label='Commission (KD)'
                        name={['rows', index, 'commission']}
                      >
                        <Input placeholder='Enter commission' />
                      </Form.Item>
                    </Col>

                    <div className='close_icon'>
                      <CloseOutlined
                        style={{}}
                        onClick={() => {
                          setFields((prev) =>
                            prev.filter((f) => f.id !== field.id),
                          );
                          form.setFieldsValue({
                            rows: form
                              .getFieldValue('rows')
                              ?.filter((_: any, i: any) => i !== index),
                          });
                        }}
                      />
                    </div>
                  </Row>
                ))}
                <div className='add_mre'>
                  <Button
                    type='dashed'
                    onClick={addFieldRow}
                    className='add_more'
                  >
                    + Add More
                  </Button>
                </div>
              </Form>
            </div>
          )}

          <p>
            <strong>Note:</strong>{' '}
            <span>Mentioned Percentage is applied on all booking.</span>
          </p>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '24px',
            }}
          >
            <Button onClick={onClose}>Cancel</Button>
            <Button type='primary' onClick={() => form.submit()}>
              Save
            </Button>
          </div>
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
